import React, { type FC, useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { applyActionCode } from "firebase/auth";
import { useNavigate, useSearchParams } from "react-router-dom";

import { AppRoutes } from "@domain/routing/routeConstants";
import { AuthLayout } from "./AuthLayout";
import { MODE_VERIFY_EMAIL } from "@domain/api/firebase/firebaseOodCodeEnums";
import { auth } from "@domain/api/firebase/firebase";
import { logger } from "@domain/infrastructure/logger";
import { Spinner, toast } from "@heroui/react";

export const VerifyEmailView: FC = () => {
    const navigate = useNavigate();
    const [query] = useSearchParams();
    const intl = useIntl();

    useEffect(() => {
        const mode = query.get("mode");
        const oobCode = query.get("oobCode");

        if (mode !== MODE_VERIFY_EMAIL) {
            return;
        }

        applyActionCode(auth, oobCode)
            .then(() => {
                toast(intl.formatMessage({ id: "app.profile.email_verification.success_message" }));
                setTimeout(() => {
                    navigate(AppRoutes.home);
                    window.location.reload();
                }, 5000);
            })
            .catch((error) => {
                logger.error(error);
                toast.danger(intl.formatMessage({ id: "app.profile.email_verification.fail_message" }));
                setTimeout(() => {
                    navigate(AppRoutes.home);
                }, 5000);
            });
    }, [intl, navigate, query]);

    return (
        <AuthLayout>
            <div className="flex flex-col justify-center items-center h-full gap-2">
                <Spinner />
                <span>
                    <FormattedMessage id="app.page.auth.confirmingEmail" />
                </span>
            </div>
        </AuthLayout>
    );
};
